export const cloudflareImage = (imageUrl: string, appBrand: string, preset: string) => {
  if (imageUrl && appBrand && preset) {
    let brandName = imageUrl.split('https://')[1].split('.')[0];

    if (brandName === 'dl-space') {
      brandName = 'dtbaPl';
    }
    const url = imageUrl.split('digitaloceanspaces.com/')[1];
    const cfurl = `https://images.activerse.pro/?image=${url}&preset=${preset}&brand=${brandName}`;
    return cfurl;
  } else {
    return imageUrl;
  }
};
